import styled, { CSSProperties } from 'styled-components';

import { BodilColor } from '~src/branding';

import { ButtonProps } from './Button/types';

type TextButtonProps = {
  fontSize?: number | 'inherit';
  fontType?: 'default' | 'heading';
  color?: string;
  textDecoration?: CSSProperties['textDecoration'];
};

const StyledButton = styled.button<TextButtonProps>(
  ({ fontSize = 'inherit', fontType = 'default', color = BodilColor.ui.action.default, textDecoration = 'none' }) => ({
    display: 'inline',
    fontSize,
    lineHeight: 'inherit',
    color,
    background: 'none',
    padding: 0,
    border: 'none',
    cursor: 'pointer',
    fontWeight: fontType === 'default' ? 'normal' : 'bold',
    textDecoration,
  })
);

type Props = ButtonProps & TextButtonProps;

export const TextButton = ({ children, ...props }: Omit<Props, 'type'>) => (
  <StyledButton {...props}>{children}</StyledButton>
);
